import { makeStyles } from '@material-ui/core/styles';
export const useFormDownloadQRCodeStyles = makeStyles(theme => ({
  form: {
    flexGrow: 1
  },
  centered: {
    display: 'flex',
    justifyContent: 'center'
  }
}));
